import { defineMessages } from 'react-intl';

export default defineMessages({
    Header: {
        id: 'cep.endorsement.SgDriversSummary.Header',
        defaultMessage: 'Drivers currently on your policy:'
    },
    Name: {
        id: 'cep.endorsement.SgDriversSummary.Name',
        defaultMessage: 'Name'
    },
    DOB: {
        id: 'cep.endorsement.SgDriversSummary.DOB',
        defaultMessage: 'Date of Birth'
    }
});
